/**
 * Marina:
 * Rental Property Filter Script
 * Built in Lovable with slight enhancements
*/

$(document).ready(function() {

	const dataUrl = '/all-rentals.json';
	let properties = [];
	let filteredProperties = [];
	let activeFilters = {
		bedrooms: '',
		bathrooms: '',
		priceRange: '',
	};
	let priceRangeValues = { min: 200, max: 2000 };
	let searchQuery = '';
	let isLoading = true;
	let hasLoadedOnce = false;
	let isPriceRangeSelected = false;

	/** Open rental detail on primary site in a new tab when it differs from this entry's URL (e.g. second site). */
	function rentalOverlayNewTabAttrs(primaryUrl, entryUrl) {
		if (!primaryUrl || primaryUrl === '#') {
			return '';
		}
		try {
			const primary = new URL(primaryUrl, window.location.href);
			if (entryUrl) {
				try {
					const entryU = new URL(entryUrl, window.location.href);
					if (primary.href !== entryU.href) {
						return ' target="_blank" rel="noopener noreferrer"';
					}
				} catch (_) {
					// ignore
				}
			}
			if (primary.origin !== window.location.origin) {
				return ' target="_blank" rel="noopener noreferrer"';
			}
		} catch (_) {
			if (entryUrl && primaryUrl !== entryUrl) {
				return ' target="_blank" rel="noopener noreferrer"';
			}
		}
		return '';
	}

	// Initial setup
	fetchRentalData();
	setupFilterDropdowns();
	setupSearchInput();
	parseUrlParams();
	setupPriceSlider();

	// Event handlers
	$(document).on('click', '[data-filter]', function() {
		const filterType = $(this).data('filter');
		const filterValue = $(this).data('value').toString();
		
		// Single select: deselect all items of this filter type first
		$(`[data-filter="${filterType}"]`).removeClass('active');
		
		// Toggle current filter
		if (activeFilters[filterType] === filterValue) {
			// If clicking on the currently selected value, clear it
			activeFilters[filterType] = '';
			$(this).removeClass('active');
		} else {
			// Otherwise, select the new value
			activeFilters[filterType] = filterValue;
			$(this).addClass('active');
		}
	
		$(this).parent().addClass('hidden');

		// Update the dropdown display text
		updateFilterText(filterType);
		
		applyFilters();
		updateUrl();
	});

	$(document).on('click', '[data-filter-clear]', function() {
		clearAllFilters();
	});

	// Setup filter dropdowns
	function setupFilterDropdowns() {
		// Toggle dropdown visibility
		$('.filter-dropdown-trigger').on('click', function() {
			const target = $(this).data('target');
			$(`#${target}`).toggleClass('hidden');
			// Close other dropdowns
			$('.filter-dropdown-content').not(`#${target}`).addClass('hidden');
		});

		// Close dropdowns when clicking outside
		$(document).on('click', function(e) {
			if (!$(e.target).closest('.filter-dropdown').length) {
				$('.filter-dropdown-content').addClass('hidden');
			}
		});
	}

	// Setup search input
	function setupSearchInput() {
		$('#property-search').on('input', function() {
			searchQuery = $(this).val().toLowerCase();
			applyFilters();
			updateUrl();
		});
	}

	// Setup price slider
	function setupPriceSlider() {
		const minHandle = $('.slider-handle-min');
		const maxHandle = $('.slider-handle-max');
		const sliderRange = $('.slider-range');
		const sliderTrack = $('.slider-track');
		const minInput = $('#priceSliderMin');
		const maxInput = $('#priceSliderMax');
		const display = $('#priceRangeDisplay');
		
		let isDragging = false;
		let dragHandle = null;

		function updatePriceSelectedText() {
			const selectedText = isPriceRangeSelected ? `$${priceRangeValues.min} - $${priceRangeValues.max}` : '';
			$('.filter-dropdown[data-filter-type="priceRange"] .selected-options').text(selectedText);
		}

		function updateSliderDisplay(options = {}) {
			const {
				markSelected = false,
				runFilters = true,
				shouldUpdateUrl = true
			} = options;
			const min = parseInt(minInput.val());
			const max = parseInt(maxInput.val());
			priceRangeValues.min = min;
			priceRangeValues.max = max;
			display.text(`$${min} - $${max}`);

			if (markSelected) {
				isPriceRangeSelected = true;
			}

			if (isPriceRangeSelected) {
				activeFilters.priceRange = `${min}-${max}`;
			} else {
				activeFilters.priceRange = '';
			}

			updatePriceSelectedText();
			
			// Update slider visual
			const minPercentage = ((min - 200) / (2000 - 200)) * 100;
			const maxPercentage = ((max - 200) / (2000 - 200)) * 100;
			
			minHandle.css('left', minPercentage + '%');
			maxHandle.css('left', maxPercentage + '%');
			sliderRange.css({
				'left': minPercentage + '%',
				'width': (maxPercentage - minPercentage) + '%'
			});
			
			if (runFilters) {
				applyFilters();
			}
			if (shouldUpdateUrl) {
				updateUrl();
			}
		}

		function getValueFromPosition(position, trackWidth) {
			const percentage = (position / trackWidth) * 100;
			const value = 200 + (percentage / 100) * (2000 - 200);
			const roundedValue = Math.round(value / 50) * 50; // Round to nearest 50
			// Constrain to min/max bounds
			return Math.max(200, Math.min(2000, roundedValue));
		}

		function startDrag(e) {
			isDragging = true;
			dragHandle = $(e.target);
			$('body').addClass('select-none');
			e.preventDefault();
		}

		function drag(e) {
			if (!isDragging || !dragHandle) return;
			
			const trackRect = sliderTrack[0].getBoundingClientRect();
			const trackWidth = trackRect.width;
			// Support both mouse and touch events
			const clientX = e.clientX || (e.touches && e.touches[0] ? e.touches[0].clientX : 0);
			const position = clientX - trackRect.left;
			const percentage = Math.max(0, Math.min(100, (position / trackWidth) * 100));
			const value = getValueFromPosition(position, trackWidth);
			
			if (dragHandle.hasClass('slider-handle-min')) {
				const maxValue = parseInt(maxInput.val());
				if (value >= maxValue || value < 200) return;
				minInput.val(value);
				dragHandle.attr('data-value', value);
			} else if (dragHandle.hasClass('slider-handle-max')) {
				const minValue = parseInt(minInput.val());
				if (value <= minValue || value > 2000) return;
				maxInput.val(value);
				dragHandle.attr('data-value', value);
			}
			
			updateSliderDisplay({ markSelected: true });
		}

		function stopDrag() {
			isDragging = false;
			dragHandle = null;
			$('body').removeClass('select-none');
		}

		// Event listeners for mouse
		minHandle.on('mousedown', startDrag);
		maxHandle.on('mousedown', startDrag);
		$(document).on('mousemove', drag);
		$(document).on('mouseup', stopDrag);
		
		// Event listeners for touch
		minHandle.on('touchstart', startDrag);
		maxHandle.on('touchstart', startDrag);
		$(document).on('touchmove', drag);
		$(document).on('touchend', stopDrag);
		
		// Initialize slider visual state without marking the price filter as selected.
		updateSliderDisplay({
			markSelected: isPriceRangeSelected,
			runFilters: false,
			shouldUpdateUrl: false,
		});
	}

	// Fetch rental data from external URL
	function fetchRentalData() {
		isLoading = true;
		updatePropertyDisplay();
		$.ajax({
			url: dataUrl,
			type: 'GET',
			dataType: 'json',
			success: function(data) {
				isLoading = false;
				hasLoadedOnce = true;
				if (data && Array.isArray(data.data)) {
					properties = data.data;
					filteredProperties = data.data;
					updatePropertyDisplay();
					updateFilterCounts();
					
					// If we have URL params, apply those filters
					if (hasActiveFilters() || searchQuery) {
						applyFilters();
					}
					return;
				}

				properties = [];
				filteredProperties = [];
				updatePropertyDisplay();
				updateFilterCounts();
			},
			error: function(xhr, status, error) {
				isLoading = false;
				hasLoadedOnce = true;
				console.error('Error fetching rental data:', error);
				$('.column-cards').html('<div class="error-message p3">Failed to load properties. Please try again later.</div>');
				$('.column-results').html('');
			}
		});
	}

	// Parse URL parameters to restore filter state
	function parseUrlParams() {
		const urlParams = new URLSearchParams(window.location.search);
		
		const bedrooms = urlParams.get('bedrooms');
		if (bedrooms) {
			activeFilters.bedrooms = bedrooms;
			$(`[data-filter="bedrooms"][data-value="${bedrooms}"]`).addClass('active');
			updateFilterText('bedrooms');
		}
		
		const bathrooms = urlParams.get('bathrooms');
		if (bathrooms) {
			activeFilters.bathrooms = bathrooms;
			$(`[data-filter="bathrooms"][data-value="${bathrooms}"]`).addClass('active');
			updateFilterText('bathrooms');
		}
		
		const priceRange = urlParams.get('priceRange');
		if (priceRange) {
			const [min, max] = priceRange.split('-').map(Number);
			if (min && max) {
				$('#priceSliderMin').val(min);
				$('#priceSliderMax').val(max);
				priceRangeValues.min = min;
				priceRangeValues.max = max;
				isPriceRangeSelected = true;
				activeFilters.priceRange = priceRange;
				$('#priceRangeDisplay').text(`$${min} - $${max}`);
				
				// Update slider visual
				const minPercentage = ((min - 200) / (2000 - 200)) * 100;
				const maxPercentage = ((max - 200) / (2000 - 200)) * 100;
				
				$('.slider-handle-min').css('left', minPercentage + '%');
				$('.slider-handle-max').css('left', maxPercentage + '%');
				$('.slider-range').css({
					'left': minPercentage + '%',
					'width': (maxPercentage - minPercentage) + '%'
				});
				
				updateFilterText('priceRange');
			}
		} else {
			// Only reset to default if no priceRange parameter exists
			activeFilters.priceRange = '';
			isPriceRangeSelected = false;
		}
		
		const search = urlParams.get('search');
		if (search) {
			searchQuery = search;
			$('#property-search').val(search);
		}

		updateFilterCounts();
	}

	// Update filter dropdown text based on selection
	function updateFilterText(filterType) {
		const selectedValue = activeFilters[filterType];
		
		if (selectedValue) {
			if (filterType === 'priceRange') {
				if (isPriceRangeSelected) {
					$(`.filter-dropdown[data-filter-type="${filterType}"] .selected-options`).text(`$${priceRangeValues.min} - $${priceRangeValues.max}`);
				} else {
					$(`.filter-dropdown[data-filter-type="${filterType}"] .selected-options`).text('');
				}
			} else {
				$(`.filter-dropdown[data-filter-type="${filterType}"] .selected-options`).text(selectedValue);
			}
		} else {
			$(`.filter-dropdown[data-filter-type="${filterType}"] .selected-options`).text('');
		}
	}

	// Apply all active filters
	function applyFilters() {
		if (!hasLoadedOnce) {
			return;
		}

		let results = [...properties];
		
		// Filter by bedrooms
		if (activeFilters.bedrooms) {
			results = results.filter(property => 
				property.bedrooms === activeFilters.bedrooms
			);
		}
		
		// Filter by bathrooms
		if (activeFilters.bathrooms) {
			results = results.filter(property => 
				property.bathrooms === activeFilters.bathrooms
			);
		}
		
		// Filter by price range
		if (activeFilters.priceRange) {
			results = results.filter(property => {
				const rentAmount = parseInt(property.propertyRentAmount);
				return rentAmount >= priceRangeValues.min && rentAmount <= priceRangeValues.max;
			});
		}
		
		// Apply text search
		if (searchQuery) {
			results = results.filter(property => {
				const addressFields = [
				property.propertyAddress1 || '',
				property.propertyAddress2 || '',
				property.propertyAddress3 || '',
				property.propertyAddress4 || ''
				].join(' ').toLowerCase();
				
				return addressFields.includes(searchQuery.toLowerCase());
			});
		}
		
		filteredProperties = results;
		updatePropertyDisplay();
		updateFilterCounts();
	}

	// Update filter counts
	function updateFilterCounts() {
		if (!hasLoadedOnce) {
			return;
		}

		// Update total count
		if (filteredProperties && filteredProperties.length !== undefined) {
			$('[data-filter-total]').text(`${filteredProperties.length} properties`);
		}
	}

	// Clear all filters
	function clearAllFilters() {
		$('[data-filter]').removeClass('active');
		
		// Reset dropdown text to defaults
		$('.filter-dropdown').each(function() {
			const defaultText = $(this).data('default-text') || '';
			$(this).find('.selected-options').text(defaultText);
		});
		
		// Clear search field
		$('#property-search').val('');
		searchQuery = '';
		
		activeFilters = {
			bedrooms: '',
			bathrooms: '',
			priceRange: '',
		};
		isPriceRangeSelected = false;
		
		// Reset price slider
		$('#priceSliderMin').val(200);
		$('#priceSliderMax').val(2000);
		priceRangeValues = { min: 200, max: 2000 };
		$('#priceRangeDisplay').text('$200 - $2000');
		
		// Reset slider visual
		$('.slider-handle-min').css('left', '0%');
		$('.slider-handle-max').css('left', '100%');
		$('.slider-range').css({
			'left': '0%',
			'width': '100%'
		});
		
		// Reset dropdown trigger text
		$('.filter-dropdown[data-filter-type="priceRange"] .selected-options').text('');
		
		filteredProperties = properties;
		updatePropertyDisplay();
		updateUrl();
		updateFilterCounts();
	}

	// Update URL with current filter state
	function updateUrl() {
		const searchParams = new URLSearchParams();
		
		if (activeFilters.bedrooms) {
			searchParams.set('bedrooms', activeFilters.bedrooms);
		}
		
		if (activeFilters.bathrooms) {
			searchParams.set('bathrooms', activeFilters.bathrooms);
		}
		
		if (activeFilters.priceRange) {
			searchParams.set('priceRange', activeFilters.priceRange);
		}
		
		if (searchQuery) {
			searchParams.set('search', searchQuery);
		}
		
		const newUrl = searchParams.toString() 
		? `${window.location.pathname}?${searchParams.toString()}` 
		: window.location.pathname;
		
		window.history.replaceState({}, '', newUrl);
	}

	// Update the property cards display
	function updatePropertyDisplay() {
		const $containerCards = $('.column-cards');
		const $containerResults = $('.column-results');
		
		if (isLoading) {
			$containerCards.html('<div class="loading p3">Loading...</div>');
			$containerResults.html('');
			return;
		}

		$containerCards.empty();
		
		if (filteredProperties.length === 0) {
			$containerCards.html('');
			if (properties.length === 0) {
				const primaryRentalsUrl = $('[data-primary-rentals-url]').data('primary-rentals-url') || '';
				let noEntriesHtml;
				try {
					const isResidences = document.body.classList.contains('theme-residences');
					if (isResidences) {
						noEntriesHtml = '<div class="no-results p3">No Glasshouse Residences are available right now, but head to Glasshouse Property Management to <a href="' + primaryRentalsUrl + '" style="text-decoration: underline;" target="_blank" rel="noopener noreferrer">view more properties.</a></div>';
					} else {
						noEntriesHtml = '<div class="no-results p3">No Glasshouse properties are available right now.</div>';
					}
				} catch (_) {
					noEntriesHtml = '<div class="no-results p3">No properties are available right now.</div>';
				}
				$containerResults.html(noEntriesHtml);
			} else {
				$containerResults.html('<div class="no-results p3">No properties found matching your filter criteria.</div>');
			}
			return;
		}

		$containerResults.html('');
		
		filteredProperties.forEach(function(property) {
			let cardHtml = `
				<div class="card-rental">
			`;

			if (property.propertyImage && property.propertyImage.length) {
				cardHtml += `
					<div class="property-image">
						<div class="property-image-container">
							<img src="${property.propertyImage}" width="540" alt="${property.title}"/>
						</div>
						<div class="arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.395" height="10.121" viewBox="0 0 14.395 10.121"><path d="M.02,0,4.55,4.53.02,9.06m-8.8-4.53H4.029" transform="translate(8.784 0.53)" fill="none" stroke="currentColor" stroke-width="1.5"/></svg></div>
					</div>
				`;
			} else {
				cardHtml += `
					<div class="property-image"></div>
				`;
			}

			cardHtml += `
				<div class="property-heading">
					<div class="property-location">
						<svg xmlns="http://www.w3.org/2000/svg" width="10" height="14.285" viewBox="0 0 10 14.285"><path d="M394-1446a5,5,0,0,0-5,5c0,3.75,5,9.285,5,9.285s5-5.536,5-9.285a5,5,0,0,0-5-5Zm0,6.786a1.786,1.786,0,0,1-1.786-1.786,1.786,1.786,0,0,1,1.786-1.786,1.786,1.786,0,0,1,1.786,1.786,1.786,1.786,0,0,1-1.786,1.786Z" transform="translate(-389 1446)" fill="currentColor" fill-rule="evenodd"/></svg>
						<span>${property.propertyUnit ? property.propertyUnit + '/' : ''}${property.propertyAddress1 ? property.propertyAddress1 + ' ' : ''}${property.propertyAddress2 ? property.propertyAddress2 : ''}${property.propertyAddress3 ? ', ' + property.propertyAddress3 : ''}</span>
					</div>
					<div class="property-price">
						$${property.propertyRentAmount}/${property.propertyRentalPeriod.toLowerCase()}
					</div>
				</div>
				<div class="property-details">
					<div class="property-area">
						${property.propertyAddress4 ? property.propertyAddress4 : ''}${property.propertyPostCode ? ', ' + property.propertyPostCode : ''}
					</div>
					<div class="property-date">
						Available ${property.propertyDateAvailable} 
					</div>
				</div>
			`;


			if (property.propertyHeader && property.propertyHeader.length) {
				cardHtml += `
					<div class="property-intro">
						${property.propertyHeader} 
					</div>
				`;
			}
			
			cardHtml += `
				<div class="property-rooms">
			`;

			if (property.bedrooms && property.bedrooms.length) {
				cardHtml += `
					<div class="property-room">
						<svg class="bed" xmlns="http://www.w3.org/2000/svg" width="40.639" height="20.761" viewBox="0 0 40.639 20.761"><g transform="translate(0)"><path d="M15.75,39.425a6.43,6.43,0,0,0-2.562-3.092,5.687,5.687,0,0,0-4.373-1.1,4.9,4.9,0,0,0-1.723.707V29H4V49.761H7.092V47.553H41.547v2.209h3.092V47.553h0V40.043H15.706A1.418,1.418,0,0,0,15.75,39.425ZM6.209,48.878H4.883V29.883H6.209Zm.883-11.927a4.244,4.244,0,0,1,1.9-.928A4.829,4.829,0,0,1,12.7,37a6.032,6.032,0,0,1,2.164,2.518.579.579,0,0,1-.044.4.335.335,0,0,1-.177.088H11.907L7.666,38.541a1.681,1.681,0,0,1-.574-.4Zm0,2.385.265.133,1.767.618H7.092Zm36.664,9.541H42.431V47.553h1.325Zm0-2.209H7.092V45.344H43.756Zm0-5.743v3.534H7.092V40.927Z" fill="currentColor" transform="translate(-4 -29)"/></g></svg>
						<span>${property.bedrooms || 'N/A'}</span>
					</div>
				`;
			}
			if (property.bathrooms && property.bathrooms.length) {
				cardHtml += `
					<div class="property-room">
						<svg class="bath" xmlns="http://www.w3.org/2000/svg" width="26" height="24.915" viewBox="0 0 26 24.915"><path d="M24.375,22.054H2.708V12.921a1.227,1.227,0,0,1,1.23-1.159H6.2a1.163,1.163,0,0,1,1.159,1.154,2.534,2.534,0,0,0-1.945,2.27v1.452a.543.543,0,0,0,.542.542H9.75a.543.543,0,0,0,.542-.542V15.186a2.455,2.455,0,0,0-1.847-2.264A2.243,2.243,0,0,0,6.2,10.679H3.938a2.312,2.312,0,0,0-2.313,2.242v9.132A1.619,1.619,0,0,0,.542,24.881V27.72a6.63,6.63,0,0,0,2.567,5.325L2.221,34.81a.541.541,0,1,0,.97.482l.834-1.663a7.414,7.414,0,0,0,3.559.877H18.417a7.414,7.414,0,0,0,3.559-.877l.834,1.663a.541.541,0,1,0,.97-.482l-.888-1.771a6.622,6.622,0,0,0,2.567-5.325V24.876a1.594,1.594,0,0,0,.542-1.2A1.623,1.623,0,0,0,24.375,22.054ZM7.9,13.929a1.39,1.39,0,0,1,1.305,1.257v.91H6.5v-.91A1.486,1.486,0,0,1,7.9,13.929ZM24.375,27.72a5.709,5.709,0,0,1-5.958,5.709H7.583A5.71,5.71,0,0,1,1.625,27.72V25.3h22.75Zm0-3.5H1.641a.555.555,0,0,1-.552-.46.542.542,0,0,1,.536-.623H24.359a.555.555,0,0,1,.553.46A.542.542,0,0,1,24.375,24.221Z" fill="currentColor" transform="translate(0 -10.679)"/></svg>
						<span>${property.bathrooms || 'N/A'}</span>
					</div>
				`;
			}
			if (property.cars && property.cars.length) {
				cardHtml += `
					<div class="property-room">
						<svg class="car" xmlns="http://www.w3.org/2000/svg" width="25.482" height="18.276" viewBox="0 0 25.482 18.276"><g transform="translate(0)"><path d="M32.147,23.435a1.379,1.379,0,0,0-.72-2.559h-.554a1.362,1.362,0,0,0-.6.144A6.061,6.061,0,0,0,25.058,17H18.412A6.061,6.061,0,0,0,13.2,21.021a1.362,1.362,0,0,0-.6-.144h-.554a1.379,1.379,0,0,0-.72,2.559A5.2,5.2,0,0,0,9,27.744v3.539A.554.554,0,0,0,9,31.4v3.323a.554.554,0,0,0,.554.554h4.43a.554.554,0,0,0,.554-.554V33.614h14.4v1.108a.554.554,0,0,0,.554.554h4.43a.554.554,0,0,0,.554-.554V31.4a.521.521,0,0,0,0-.089,1.429,1.429,0,0,0,0-.222V27.766a5.2,5.2,0,0,0-2.326-4.331Zm-1.274-1.451h.554a.277.277,0,1,1,0,.554h-.554a.277.277,0,0,1,0-.554Zm-16.708,0c0-1.739,2.343-3.877,4.248-3.877h6.646c1.905,0,4.248,2.138,4.248,3.877v.554H14.165Zm-2.121,0H12.6a.277.277,0,1,1,0,.554h-.554a.277.277,0,1,1,0-.554Zm2.248,1.661H29.178a4.148,4.148,0,0,1,4.187,4.1v.332H29.859a.554.554,0,0,0,0,1.108h3.506v1.905a1.5,1.5,0,0,1,0,.222,1.451,1.451,0,0,1-1.457,1.2H11.562a1.34,1.34,0,0,1-.26,0,1.44,1.44,0,0,1-1.2-1.2,1.5,1.5,0,0,1,0-.222V29.278h3.506a.554.554,0,1,0,0-1.108H10.105v-.426a4.148,4.148,0,0,1,4.187-4.1Zm-.864,10.522H10.105v-1a.715.715,0,0,0,.089.05l.138.083.238.111.144.055a2.271,2.271,0,0,0,.277.078h.138a2.724,2.724,0,0,0,.432.039h1.866Zm19.937,0H30.042v-.554h1.866a2.725,2.725,0,0,0,.432-.039h.138a2.271,2.271,0,0,0,.277-.078l.15-.055.233-.111.138-.083.089-.078ZM16.934,31.216h9.6a1.85,1.85,0,0,0,0-3.694h-9.6a1.85,1.85,0,0,0,0,3.694Zm0-2.586h9.6a.742.742,0,0,1,0,1.479h-9.6a.742.742,0,0,1,0-1.479Z" transform="translate(-8.994 -17)" fill="currentColor"/></g></svg>
						<span>${property.cars || 'N/A'}</span>
					</div>
				`;
			}
					
			const overlayHref = property.url || '#';
			const entryHref = property.entryUrl || property.defaultUrl;
			const overlayNewTabAttrs = rentalOverlayNewTabAttrs(overlayHref, entryHref);

			cardHtml += `
				</div>
				<a class="link-overlay" href="${overlayHref}"${overlayNewTabAttrs}></a>
			</div>`;

			const $card = $(cardHtml);
			
			$containerCards.append($card);
		});
	}

	// Helper function to check if there are any active filters
	function hasActiveFilters() {
		return (
			activeFilters.bedrooms !== '' || 
			activeFilters.bathrooms !== '' ||
			activeFilters.priceRange !== ''
		);
	}

});